import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-venaqi-services',
  templateUrl: './venaqi-services.component.html',
  styleUrls: ['./venaqi-services.component.scss']
})
export class VenaqiServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
